<template>
    <div class="" id="City">
        <mt-header fixed title="城市">
            <!-- <router-link to="/" slot="left"> -->
            <mt-button @click="goback" slot="left" icon="back">返回</mt-button>
            <!-- </router-link> -->
        </mt-header>
        <mt-index-list>
            <mt-index-section index="*">
                <mt-cell>
                    <span>不限城市</span>
                </mt-cell>
            </mt-index-section>
            <mt-index-section index="A">
                <mt-cell>
                    <span>福建</span>
                </mt-cell>
                <mt-cell>
                    <span>福建</span>
                </mt-cell>
                <mt-cell>
                    <span>福建</span>
                </mt-cell>
            </mt-index-section>
            <mt-index-section index="B">
                <mt-cell>
                    <span>福建</span>
                </mt-cell>
                <mt-cell>
                    <span>福建</span>
                </mt-cell>
                <mt-cell>
                    <span>福建</span>
                </mt-cell>
            </mt-index-section>
            <mt-index-section index="C">
                <mt-cell>
                    <span>福建</span>
                </mt-cell>
                <mt-cell>
                    <span>福建</span>
                </mt-cell>
                <mt-cell>
                    <span>福建</span>
                </mt-cell>
            </mt-index-section>
            <mt-index-section index="D">
                <mt-cell>
                    <span>福建</span>
                </mt-cell>
                <mt-cell>
                    <span>福建</span>
                </mt-cell>
                <mt-cell>
                    <span>福建</span>
                </mt-cell>
            </mt-index-section>
            <mt-index-section index="E">
                <mt-cell>
                    <span>福建</span>
                </mt-cell>
                <mt-cell>
                    <span>福建</span>
                </mt-cell>
                <mt-cell>
                    <span>福建</span>
                </mt-cell>
            </mt-index-section>
            <mt-index-section index="F">
                <mt-cell>
                    <span>福建</span>
                </mt-cell>
                <mt-cell>
                    <span>福建</span>
                </mt-cell>
                <mt-cell>
                    <span>福建</span>
                </mt-cell>
            </mt-index-section>
            <mt-index-section index="FFF">
                <mt-cell>
                    <span>福建</span>
                </mt-cell>
                <mt-cell>
                    <span>福建</span>
                </mt-cell>
                <mt-cell>
                    <span>福建</span>
                </mt-cell>
            </mt-index-section>
        </mt-index-list>
        <!-- <div class="car_system" style="display:none">
            <div class="box">
                <ul>
                    <li>厦门</li>
                    <li>厦门</li>
                    <li>厦门</li>
                    <li>厦门</li>
                    <li>厦门</li>
                    <li>厦门</li>
                    <li>厦门</li>
                    <li>厦门</li>
                    <li>厦门</li>
                    <li>厦门</li>
                    <li>厦门</li>
                    <li>厦门</li>
                </ul>
            </div>
        </div> -->
    </div>
</template>

<script>
import { Header, IndexList, IndexSection } from "mint-ui";
import { API_GET, API_POST, getLocation } from "@/apiConfig";
export default {
    name: "CarDetails",
    data() {
        return {
            msg: "Welcome to Your Vue.js App"
        };
    },
    mounted() {
        let body = {
            carId
        }
        // API_GET("http://localhost:8001/api/test/movie", {}, true)
        //     .then(res => {
        //         console.log(res, "resres");
        //     })
        //     .catch(res => {
        //         console.log(res, "resres");
        //     });
    },
    methods: {
        goback: function() {
            window.history.go(-1)
        },

        onShowSortFlag: function(sortFlag) {
            console.log(sortFlag, "sortFlagsortFlag");
            if (this.sortFlag == sortFlag) {
                this.sortFlag = "";
            } else {
                this.sortFlag = sortFlag;
            }
        }
    },
    loadMore() {
        this.loading = true;
        setTimeout(() => {
            let last = this.list[this.list.length - 1];
            for (let i = 1; i <= 10; i++) {
                this.list.push(last + i);
            }
            this.loading = false;
        }, 2500);
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mint-header-button > a {
    color: #2c2c2c;
}
</style>



// WEBPACK FOOTER //
// src/components/City.vue